/* global axios */
import ApiClient from '../ApiClient';

class MercadoPagoApi extends ApiClient {
  constructor() {
    super('integrations/mercado_pago', { accountScoped: true });
  }

  status() {
    return axios.get(this.url);
  }

  createPayment({
    kind,
    amountCents,
    description,
    conversationId,
    contactId,
    contactName,
    contactEmail,
    posOrderId,
  }) {
    return axios.post(`${this.url}/payments`, {
      kind,
      amount_cents: amountCents,
      description,
      conversation_id: conversationId,
      contact_id: contactId,
      contact_name: contactName,
      contact_email: contactEmail,
      pos_order_id: posOrderId,
    });
  }
}

export default new MercadoPagoApi();
